module.exports = __webpack_public_path__ + "img/itabpic6.57edf768.jpg";